export interface FunctionTypes {
  toggleTableCombinationsPanel(): BaseTockAction;
}

export function toggleTableCombinationsPanel(): BaseTockAction {
  return {
    type: 'TOGGLE_TABLE_COMBINATIONS_PANEL',
  };
}
